import type {Placement} from '@floating-ui/vue'

export type PlacementSide = 'top' | 'bottom' | 'left' | 'right'

export function getPlacementSide(placement: Placement): PlacementSide {
  return placement.split('-')[0] as PlacementSide
}
